// extracted by mini-css-extract-plugin
export default {"NewOrderListPage":"NewOrderListPage_NewOrderListPage__VsvSE"};